import { Component, OnInit, OnDestroy, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';

export interface PasswordFormValues
{
    password: string;
    verifyPassword: string;
}

@Component({
    selector: 'aa-create-pswd-form',
    templateUrl: './create-pswd-form.component.html',
    styleUrls: [
        './create-pswd-form.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CreatePswdFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CreatePswdFormComponent),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreatePswdFormComponent implements ControlValueAccessor, OnDestroy
{
    form: UntypedFormGroup;
    onChange: any = () => { };
    onTouched: any = () => { };

    get value ()
    {
        return this.form.value;
    }
    set value (value)
    {
        this.form.setValue(value);
        this.onChange(value);
        this.onTouched();
    }

    constructor(formBuilder: UntypedFormBuilder)
    {
        this.form = formBuilder.group(
            {
                password: ['', [Validators.required, Validators.minLength(4)]],
                verifyPassword: ['', [Validators.required]]
            },
            // {
            //     validator: matchingInputsValidator('password', 'confirmPassword', 'missmatch')
            // }
        );
    }

    ngOnDestroy (): void
    {
        throw new Error('Method not implemented.');
    }

    markAsDirty ()
    {
        Object.keys(this.form.controls).forEach(field =>
        {
            const control = this.form.get(field);

            control.markAsDirty();
        });
    }

    writeValue (value: any): void
    {
        if (value)
        {
            this.value = value;

        }
    }
    registerOnChange (fn: any): void
    {
        this.onChange = fn;
    }
    registerOnTouched (fn: any): void
    {
        this.onTouched = fn;
    }

    validate (_: UntypedFormControl)
    {
        return this.form.valid ? null : { profile: { valid: false, }, };
    }
}
